<script>
	module.exports = {
		props: {
			items: {
				default: null
			},
			dataItem: {
				default: null
			},
			iconCls: {
				default: 'ellipsis fa-solid'
			},
			iconAfter: {
				default: false
			},
			optionHeaderText: {
				default: 'Select an option:'
			},
			titleText: {
				default: ''
			},
			disabled: {
				default: false
			}
		},
		data() {
			return {
				open: false
			};
		},
		methods: {
			documentClickHandler(e) {
				if (e && e.target) {
					let el = this.$el;
					let target = e.target;
					if (!el || $(el).find(target).length < 1) {
						this.open = false;
						document.removeEventListener('click', this.documentClickHandler);
					}
				}
			},
			onButtonClick() {
				if (this.disabled) {
					return;
				}

				this.open = !this.open;

				if (this.open) {
					document.addEventListener('click', this.documentClickHandler);
				} else {
					document.removeEventListener('click', this.documentClickHandler);
				}
			}
		},
		destroy() {
			document.removeEventListener('click', this.documentClickHandler);
		}
	};
</script>
<style lang="scss">
	@import 'config/variables';
	@import 'config/colors';

	.dropdown-button {
		position: relative;

		.main-button {
			cursor: pointer;
			color: $c-slate-dark;
			background-color: transparent;
			padding: 4px;
			border-radius: 4px 4px 0px 0px;
			border: 1px solid transparent;

			.title-text {
				display: none;
			}

			&:hover {
				color: $c-blue-dark;
			}

			&.overlay {
				display: none;
				top: 0;
				left: 0;
				position: absolute;
			}

			&.disabled {
				opacity: 0.4;
				color: $c-slate-dark;
				border: 1px solid transparent;
				cursor: default;
			}
		}

		.dropdown-menu-container {
			display: none;
			position: absolute;
			background-color: rgba(22, 22, 22, 0.5);

			.dropdown-menu {
				z-index: 1;
				background-color: $c-white;
				border: 1px solid $c-blue;
				min-width: 10rem;
				border-radius: 4px 4px 4px 4px;

				.menu-item {
					padding: 0.5rem 1rem;
					cursor: pointer;

					&:hover,
					&.selected {
						color: $c-white;
						background-color: $c-blue-dark;
					}
				}
			}
		}

		&.open {
			.main-button {
				z-index: 0;
				background-color: white;

				&.overlay {
					color: $c-blue;
					display: none;
				}
			}

			.dropdown-menu-container {
				display: block;
				position: fixed;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;
				z-index: 1;

				.dropdown-menu {
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);

					> *:not(:last-child) {
						border-bottom: 1px solid $c-grey;
					}

					.mobile-header {
						cursor: normal;
						padding: 0.5rem 1rem;
						color: $c-slate-dark;
					}
				}
			}
		}

		&.active {
			&.open {
				.main-button.overlay {
					background-color: $c-white;
					color: $c-blue;
				}
			}

			.main-button {
				background-color: $c-blue;
				border-color: $c-blue;
				color: $c-white;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.dropdown-button {
			position: relative;

			.main-button {
				z-index: 0;
				border: 1px solid transparent;

				.title-text {
					display: inline-block;
				}
			}

			.dropdown-menu-container {
				background-color: transparent;

				.dropdown-menu {
					border-radius: 4px 0px 4px 4px;

					.mobile-header {
						display: none;
					}
				}
			}

			&.open {
				.main-button.overlay {
					display: block;
					z-index: 2;
					border-color: $c-blue;
					border-bottom-color: white;
				}

				.dropdown-menu-container {
					display: block;
					position: absolute;
					right: 0px;
					top: calc(100% - 1px);
					bottom: auto;
					left: auto;

					.dropdown-menu {
						position: relative;
						top: auto;
						left: auto;
						transform: none;
					}
				}
			}
		}
	}
</style>
<template>
	<div
		class="dropdown-button"
		:class="{
			open: open
		}"
		@click="onButtonClick">
		<div
			class="main-button"
			:class="{
				disabled: disabled
			}"
			:disabled="disabled">
			<i
				v-if="!iconAfter"
				:class="`fa-${iconCls}`"
				aria-hidden="true"></i>
			<span class="title-text">{{ titleText }}</span>
			<i
				v-if="iconAfter"
				:class="`fa-${iconCls}`"
				aria-hidden="true"></i>
			<div class="main-button overlay">
				<i
					v-if="!iconAfter"
					:class="`fa-${iconCls}`"
					aria-hidden="true"></i>
				<span class="title-text">{{ titleText }}</span>
				<i
					v-if="iconAfter"
					:class="`fa-${iconCls}`"
					aria-hidden="true"></i>
			</div>
		</div>
		<div class="dropdown-menu-container">
			<div class="dropdown-menu">
				<div class="mobile-header">
					{{ optionHeaderText }}
				</div>
				<div
					v-for="item in items"
					:key="item.text"
					class="menu-item"
					:class="{
						selected: item.selected
					}"
					@click="$emit('click-item', item, dataItem)">
					{{ item.text }}
				</div>
			</div>
		</div>
	</div>
</template>
